import { render, staticRenderFns } from "./permision.vue?vue&type=template&id=10784bf7&scoped=true&"
import script from "./permision.vue?vue&type=script&lang=js&"
export * from "./permision.vue?vue&type=script&lang=js&"
import style0 from "./permision.vue?vue&type=style&index=0&id=10784bf7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10784bf7",
  null
  
)

export default component.exports